interface SESSION_STORAGES_KEYS_TYPES {
    UNIQUE_TOKEN: string
    REDIRECT_TO_URL: string
    UNIQUE_ACCESS: string
    CONTACTS_BIOMETRY: string
}

export const SESSION_STORAGES_KEYS = {
    UNIQUE_TOKEN: '@uniqueToken',
    REDIRECT_TO_URL: '@redirectToUrl',
    UNIQUE_ACCESS: '@uniqueAccess',
    CONTACTS_BIOMETRY: '@LiviaAuth:ContactsBiometry',
} as SESSION_STORAGES_KEYS_TYPES
